export default {
	mobile: 960
};
